import { skills } from '@/data';
import { Section } from '@/components/layout/Section';
import { Badge } from '@/components/ui/Badge';
import { Reveal } from '@/components/ui/Reveal';

/**
 * Grouped badge clusters, not proficiency bars.
 *
 * Neither source resume assigns levels, and rendering "React — 4/5" would
 * fabricate a claim on a document employers read as factual (PLAN.md §4.5).
 */
export function Skills() {
  const ordered = [...skills].sort(
    (a, b) => Number(Boolean(b.featured)) - Number(Boolean(a.featured)),
  );

  return (
    <Section id="skills" title="Skills">
      <div className="space-y-7">
        {ordered.map((group, i) => (
          <Reveal key={group.category} index={i}>
            <h3 className="text-sm font-semibold tracking-wide text-muted-foreground uppercase">
              {group.category}
            </h3>
            <div className="mt-2.5 flex flex-wrap gap-2">
              {group.skills.map((skill) => (
                <Badge key={skill} variant={group.featured ? 'accent' : 'default'}>
                  {skill}
                </Badge>
              ))}
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
